import {
  DEMO_ACTION_TYPE_ONE,
  DEMO_ACTION_TYPE_TWO,
  RESET_STATE,
} from "../Actions/Types";

const INIT_STATE = {
  one: null,
  two: null,
};

const ReducerTypeOne = (state = INIT_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case DEMO_ACTION_TYPE_ONE:
      return { ...state, one: payload };

    case DEMO_ACTION_TYPE_TWO:
      return { ...state, two: payload };

    case RESET_STATE:
      return { ...INIT_STATE };

    default:
      return state;
  }
};
export default ReducerTypeOne;
